// These styles are shared between h1, h2, h3, h4, h5, h6, p, ol, ul, and
// potentially more since the time of writing. If you want to add a new style,
// make sure it can be used by _all_ of those elements. If not, it's a better
// idea to include it on the individual component.
export const STYLES = [
  "color",
  "fontFamily",
  "fontSize",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "textTransform"
]

/**
 * Many rich text elements inherit their style properties from a theme. This
 * function provides a shorthand to apply styles to an element without needing
 * to type them out individually.
 *
 * ```js
 * <h1 style={{ ...typographyStyles("h1", find), foo: "bar" }}>
 * ```
 *
 * @param {String} tag
 * @param {Function} find
 * @returns {Object} object containing inline styles
 */
export default function typographyStyles(tag, find) {
  const result = {}

  STYLES.forEach(key => {
    const style = find(tag, key)
    if (!style) return
    result[key] = style
  })

  return result
}
